import { useServerTranslation } from "@/app/i18n";
import NotFoundNearbyVenuesClient from "@/components/views/list/close-venues/NotFoundNearbyVenuesClient";

export default async function NotFoundNearbyVenues() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = await useServerTranslation("tr", "site");

  const titleKey = t("search-not-found-title", {
    defaultValue: "İşletme Bulunamadı",
  });
  const searchKey = t("search-not-found-venue-button", {
    defaultValue: "İşletme Ara",
  });
  const showAllText = t("search-not-found-list-all-venues-button", {
    defaultValue: "Tüm İşletmeleri Listele",
  });

  return (
    <NotFoundNearbyVenuesClient
      title={titleKey}
      showAllText={showAllText}
      searchText={searchKey}
    />
  );
}
